module.exports = __webpack_public_path__ + "static/media/Finnovex-East-Africa-2024.b23f2425.png";